import { useState, useEffect} from "react";
import { BrowserRouter as Router, Route, Routes, Link, useParams} from "react-router-dom";
import { Button } from "./components/ui/button.tsx";
import { Input } from "./components/ui/input.tsx";
import { Select } from "./components/ui/select.tsx";
import { Card, CardContent, CardHeader, CardTitle } from "./components/ui/card.tsx";
import { Badge } from "./components/ui/badge.tsx";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./components/ui/table.tsx";
import { AddTeamPage } from "./components/sections/addTeam.tsx";
import { TeamList } from "./components/sections/teamList.tsx";
import { Leaderboard } from "./components/sections/leaderboard.jsx";
import { Rounds } from "./components/sections/rounds.tsx";
import { PlayerMatch } from "./components/sections/playerMatch.tsx";
import supabase from "./config/supabaseClient.js";

const AppTVT = () => {

  const [teams, setTeams] = useState([
    { name: "CHS-A", players: [{ name: "CHS-A-1", rating: 1200, wins: 0}, { name: "CHS-A-2", rating: 1300, wins: 0 }, { name: "CHS-A-3", rating: 1250, wins: 0 }, { name: "CHS-A-4", rating: 1220, wins: 0 }], points: 0 },
    { name: "CHS-B", players: [{ name: "CHS-B-1", rating: 1190, wins: 0}, { name: "CHS-B-2", rating: 1280, wins: 0 }, { name: "CHS-B-3", rating: 1240, wins: 0 }, { name: "CHS-B-4", rating: 1210, wins: 0 }], points: 0 },
    { name: "LHS-A", players: [{ name: "LHS-A-1", rating: 1320, wins: 0}, { name: "LHS-A-2", rating: 1350, wins: 0 }, { name: "LHS-A-3", rating: 1290, wins: 0 }, { name: "LHS-A-4", rating: 1310, wins: 0 }], points: 0 },
    { name: "LHS-B", players: [{ name: "LHS-B-1", rating: 1260, wins: 0 }, { name: "LHS-B-2", rating: 1230, wins: 0 }, { name: "LHS-B-3", rating: 1270, wins: 0 }, { name: "LHS-B-4", rating: 1240, wins: 0 }], points: 0 },
    { name: "BHMS-A", players: [{ name: "BHMS-A-1", rating: 1330, wins: 0 }, { name: "BHMS-A-2", rating: 1290, wins: 0 }, { name: "BHMS-A-3", rating: 1340, wins: 0 }, { name: "BHMS-A-4", rating: 1300, wins: 0 }], points: 0 },
    { name: "BHMS-B", players: [{ name: "BHMS-B-1", rating: 1230, wins: 0 }, { name: "BHMS-B-2", rating: 1270, wins: 0 }, { name: "BHMS-B-3", rating: 1220, wins: 0 }, { name: "BHMS-B-4", rating: 1250, wins: 0 }], points: 0 },
    { name: "THS-A", players: [{ name: "THS-A-1", rating: 1310, wins: 0 }, { name: "THS-A-2", rating: 1360, wins: 0 }, { name: "THS-A-3", rating: 1280, wins: 0 }, { name: "THS-A-4", rating: 1320, wins: 0 }], points: 0 }
  ]);
  const [newTeam, setNewTeam] = useState({ name: "", players: [] });
  const [newPlayer, setNewPlayer] = useState({ name: "", rating: 1200 });
  const [matches, setMatches] = useState([]);
  const [rounds, setRounds] = useState([]);
  
  async function addPlayerdb(playerData) {
    const { data, error } = await supabase
    .from('player_tvt')  // Table name
    .insert([playerData])  // Insert player data
    .single();

    return data
  }

  async function addTeam() {
    if (newTeam.name.trim() === "" || newTeam.players.length === 0) return;
    
    let playerIDS = [];
    for (const player of newTeam.players) {
      await addPlayerdb(player);
    }
    const { data, error1 } = await supabase
      .from('player_tvt')  // Replace 'players' with your table name
      .select('*')
      .order('id', { ascending: false })  // Order by 'id' in descending order
      .limit(newTeam.players.length);  // Get all the players we just added
      
    if (data && data.length > 0) {
      // Get IDs in reverse order (newest first)
      playerIDS = data.reverse().map(p => p.id);
    }

    const { error } = await supabase
    .from('team_tvt')
    .insert({name:newTeam.name, points:0, players:playerIDS })

    setTeams([...teams, { ...newTeam, points: 0 }]);
    setNewTeam({ name: "", players: [] });
  }

  const addPlayer = () => {
    if (newPlayer.name.trim() === "") return;
    setNewTeam({ ...newTeam, players: [...newTeam.players, { ...newPlayer, wins: 0 }] });
    setNewPlayer({ name: "", rating: 1200 });
  };
  const copyLatestRoundData = async () => {
  try {
    const { data, error } = await supabase
      .from("rounds_swiss")
      .select("all_matches, time")
      .order("id", { ascending: false })
      .limit(1);

    if (error) {
      console.error("Error fetching latest round data:", error);
      alert("Failed to fetch data from Supabase.");
      return;
    }

    if (!data || data.length === 0) {
      alert("No round data found.");
      return;
    }

    const latest = data[0];
    const jsonData = {
      all_matches: latest.all_matches || [],
      time: latest.time || null,
    };

    await navigator.clipboard.writeText(JSON.stringify(jsonData, null, 2));
    alert("✅ Latest round data copied to clipboard!");
  } catch (err) {
    console.error("Clipboard error:", err);
    alert("Failed to copy to clipboard.");
  }
};
async function generateSwissRound() {
  let updatedTeams = [...teams];

  // Sort teams by points, then individual wins (tiebreaker)
  updatedTeams.sort((a, b) => {
    if (b.points === a.points) {
      const aWins = a.players.reduce((acc, p) => acc + p.wins, 0);
      const bWins = b.players.reduce((acc, p) => acc + p.wins, 0);
      return bWins - aWins;
    }
    return b.points - a.points;
  });

  let availableTeams = [...updatedTeams];
  let roundMatches = [];
  let allMatchesCopy = [...matches];
  let matchIdCounter = allMatchesCopy.length; // start from current number of matches

  // Handle odd number of teams with BYE
  if (availableTeams.length % 2 !== 0) {
    const byeTeam = availableTeams.pop();
    byeTeam.points += 1; // award point
    // ✅ Do NOT create a match object for BYE
      await supabase
    .from("team_tvt")
    .update({ points: byeTeam.points })
    .eq("name", byeTeam.name)
}
    
    const copyLatestRoundData = async () => {
  try {
    const { data, error } = await supabase
      .from("rounds_tvt")
      .select("all_matches, time")
      .order("id", { ascending: false })
      .limit(1);

    if (error) {
      console.error("Error fetching latest round data:", error);
      alert("Failed to fetch data from Supabase.");
      return;
    }

    if (!data || data.length === 0) {
      alert("No round data found.");
      return;
    }

    const latest = data[0];
    const jsonData = {
      all_matches: latest.all_matches || [],
      time: latest.time || null,
    };

    await navigator.clipboard.writeText(JSON.stringify(jsonData, null, 2));
    alert("✅ Latest round data copied to clipboard!");
  } catch (err) {
    console.error("Clipboard error:", err);
    alert("Failed to copy to clipboard.");
  }
};

  // Pair teams greedily: top vs next
  while (availableTeams.length > 1) {
    const team1 = availableTeams.shift();
    const team2 = availableTeams.shift();

    let match = {
      id: matchIdCounter++, // unique ID for routing
      team1: team1.name,
      team2: team2.name,
      players1: team1.players,
      players2: team2.players,
      result: null,
      playerMatches: generatePlayerMatches(team1.players, team2.players, rounds.length),
      round: rounds.length,
      submitted: false
    };

    roundMatches.push(match);
    allMatchesCopy.push(match);
  }

  // Append new round
  const updatedRounds = [...rounds, roundMatches];
  const updatedMatches = [...matches, ...roundMatches];

  setRounds(updatedRounds);
  setMatches(updatedMatches);

  // Persist to Supabase
  await addRounds(updatedRounds, updatedMatches);
}



async function fetchRounds() {
  const { data, error } = await supabase
    .from('rounds_tvt')
    .select("data, all_matches")
    .order('id', { ascending: false })
    .limit(1);

  if (error) {
    console.error("Supabase error:", error);
    return;
  }

  if (data && data.length > 0) {
    const latest = data[0];
    setRounds(latest.data || []);          // ✅ only keep the inner rounds
    setMatches(latest.all_matches || []);  // ✅ only keep matches
  } else {
    setRounds([]);
    setMatches([]);
  }
}


  

async function addRounds(newRounds, newAllMatches) {
  const { data, error } = await supabase
    .from('rounds_tvt')
    .insert([{ data: newRounds, all_matches: newAllMatches }]) // ✅ always insert raw array
    .select();

  if (error) {
    console.error("Supabase error:", error);
    return;
  }

  console.log("Inserted data:", data);
}


  async function fetchPlayers(ids){
    let playerLists = [];
    const { data, error } = await supabase
    .from('player_tvt')
    .select("*")
    .in("id", ids)
    data.forEach(player => {
      playerLists.push({name: player.name, id:player.id, rating: player.rating, wins:player.wins})
    })
    return playerLists
  }
  
  async function fetchTeams() {
    let teams_new = [];
    const { data, error } = await supabase.from("team_tvt").select();
    if (error) {
      console.error("Error fetching teams:", error);
      return;
    }
  
    // Use 'for...of' to be able to use 'await'
    for (const team of data) {
      // Ensure team.players is in the correct format
      let playerIds = team.players
      
      // Await fetchPlayers
      let player_list = await fetchPlayers(playerIds);

      teams_new.push({
        id: team.id,
        name: team.name,
        points: team.points,
        players: player_list,
      });
    }
  
    setTeams(teams_new);
    return teams_new;
  }
  
  useEffect(() => {
    fetchRounds();
    fetchTeams();
  }, []);

  const assignColor = () => {
    let pairity = false;
    teams.forEach(team => {
      team.players.forEach(player =>{
        if(pairity){
          player.color = "bw".repeat(teams.length);
        }else{
          player.color = "wb".repeat(teams.length);
        }
        pairity = !pairity;
      })
    });
  }
  assignColor()


  const determineMatchWinner = (match) => {
    let team1Wins = match.playerMatches.filter(pm => pm.result === pm.player1).length;
    let team2Wins = match.playerMatches.filter(pm => pm.result === pm.player2).length;
    return team1Wins > team2Wins ? match.team1 : team2Wins > team1Wins ? match.team2 : "draw";
  };

const recordPlayerMatchResult = async (matchId, playerMatchIndex, winner) => {
  const newMatches = [...matches];
  const match = newMatches[matchId];
  const playerMatch = match.playerMatches[playerMatchIndex];

  // Find teams
  const team1 = teams.find(t => t.name === match.team1);
  const team2 = teams.find(t => t.name === match.team2);
  if (!team1 || !team2) return;

  // Find players
  const p1 = team1.players.find(p => p.name === playerMatch.player1);
  const p2 = team2.players.find(p => p.name === playerMatch.player2);
  if (!p1 || !p2) return;

  // Only adjust wins if match is NOT submitted
  if (!match.submitted) {
    // Undo previous result if any
    if (playerMatch.result) {
      switch (playerMatch.result) {
        case "draw":
          p1.wins -= 0.5;
          p2.wins -= 0.5;
          break;
        case playerMatch.player1:
          p1.wins -= 1;
          break;
        case playerMatch.player2:
          p2.wins -= 1;
          break;
      }
    }

    // Apply new result
    switch (winner) {
      case "draw":
        p1.wins += 0.5;
        p2.wins += 0.5;
        break;
      case playerMatch.player1:
        p1.wins += 1;
        break;
      case playerMatch.player2:
        p2.wins += 1;
        break;
    }

    // Persist player wins in DB
    await Promise.all([
      supabase.from("player_tvt").update({ wins: p1.wins }).eq("id", p1.id),
      supabase.from("player_tvt").update({ wins: p2.wins }).eq("id", p2.id),
    ]);
  }

  // Update the match result and state
  playerMatch.result = winner;
  match.result = determineMatchWinner(match);

  const updatedRounds = [...rounds];
  const roundIndex = match.round;
  const matchIndex = updatedRounds[roundIndex].findIndex(m => m.id === match.id);
  updatedRounds[roundIndex][matchIndex] = match;

  setMatches(newMatches);
  setRounds(updatedRounds);
  setTeams([...teams]);
};




const clearTeamPoints = async () => {
   console.log("HEY")
  const {data, err} = await supabase
    .from('team_tvt')
    .update({"points": 0})
    .neq("id", -1);
    window.location.reload()
}


const clearPlayerPoints = async () => {
  console.log("HEY")
  const {data, err} = await supabase
    .from('player_tvt')
    .update({"wins": 0})
    .neq("id", -1);
    window.location.reload()
}

const clearRounds = async () => {
  const res = await supabase
    .from('rounds_tvt')
    .delete()
    .neq("id", -1);
    window.location.reload()
}

const clearTeams = async () => {
  const res = await supabase
    .from('team_tvt')
    .delete()
    .neq("id", -1);

  const res1 = await supabase
    .from('player_tvt')
    .delete()
    .neq("id", -1);
    window.location.reload()
}


const RevokeSubmit = async (match) => {
  if (!match.submitted) return;

  const updatedTeams = [...teams];
  const team1 = updatedTeams.find(t => t.name === match.team1);
  const team2 = updatedTeams.find(t => t.name === match.team2);
  if (!team1 || !team2) return;

  // Undo team points
  if (match.result === match.team1) team1.points -= 2;
  else if (match.result === match.team2) team2.points -= 2;
  else { team1.points -= 1; team2.points -= 1; }

  // Undo player wins
  match.playerMatches.forEach(pm => {
    const p1 = team1.players.find(p => p.name === pm.player1);
    const p2 = team2.players.find(p => p.name === pm.player2);
    if (!p1 || !p2) return;

    if (pm.result === "draw") { p1.wins -= 0.5; p2.wins -= 0.5; }
    else if (pm.result === pm.player1) { p1.wins -= 1; }
    else if (pm.result === pm.player2) { p2.wins -= 1; }

    // ✅ Clear the previous result so no double subtraction happens
    pm.result = null;
  });

  // Update DB for players
  await Promise.all(
    team1.players.concat(team2.players).map(p =>
      supabase.from("player_tvt").update({ wins: p.wins }).eq("id", p.id)
    )
  );

  // Update teams in DB
  await Promise.all([
    supabase.from("team_tvt").update({ points: team1.points }).eq("id", team1.id),
    supabase.from("team_tvt").update({ points: team2.points }).eq("id", team2.id)
  ]);

  match.submitted = false;

  // Update rounds + matches in state and Supabase
  const updatedRounds = [...rounds];
  const roundIndex = match.round;
  const matchIndex = updatedRounds[roundIndex].findIndex(m => m.id === match.id);
  updatedRounds[roundIndex][matchIndex] = match;

  const updatedMatches = [...matches];
  updatedMatches[match.id] = match;

  setRounds(updatedRounds);
  setMatches(updatedMatches);
  setTeams(updatedTeams);

  await addRounds(updatedRounds, updatedMatches);
};

const generate1v1Rounds = async () => {
  if (teams.length < 2) {
    alert("Need at least 2 teams for 1v1 format!");
    return;
  }

  // For simplicity, assume only two teams are selected for 1v1
  const team1 = teams[0];
  const team2 = teams[1];
  const players1 = team1.players;
  const players2 = team2.players;

  // Ensure equal number of players (optional)
  const maxPlayers = Math.max(players1.length, players2.length);
  const p1 = [...players1];
  const p2 = [...players2];

  // Rotate players2 cyclically to create unique pairings
  let roundsData = [];
  let allMatches = [];
  console.log(p1, p2);

  for (let round = 0; round < maxPlayers; round++) {
    let playerMatches = [];

    for (let i = 0; i < maxPlayers; i++) {
      const player1 = p1[i];
      const player2Index = (i + round) % p2.length;
      const player2 = p2[player2Index];
      playerMatches.push({
        player1: player1.name,
        player2: player2.name,
        result: null
      });
    }

    let match = {
      id: allMatches.length,
      team1: team1.name,
      team2: team2.name,
      players1: team1.players,
      players2: team2.players,
      playerMatches,
      result: null,
      round,
      submitted: false
    };



    roundsData.push([match]); // one match per round
    allMatches.push(match);
  }

  // Save and persist
  setRounds(roundsData);
  setMatches(allMatches);
  console.log(allMatches);
  await addRounds(roundsData, allMatches);
  // window.location.reload()
  console.log("Generated 1v1 rounds:", roundsData);
};


const Submit = async (match) => {
  // Prevent double-submit
  if (match.submitted) return;

  let updatedTeams = [...teams];
  let team1 = updatedTeams.find(team => team.name === match.team1);
  let team2 = updatedTeams.find(team => team.name === match.team2);

  if (match.result === match.team1) {
    team1.points += 2;
    await supabase.from("team_tvt").update({ points: team1.points }).eq("id", team1.id);
  } else if (match.result === match.team2) {
    team2.points += 2;
    await supabase.from("team_tvt").update({ points: team2.points }).eq("id", team2.id);
  } else {
    team1.points += 1;
    team2.points += 1;
    await supabase.from("team_tvt").update({ points: team1.points }).eq("id", team1.id);
    await supabase.from("team_tvt").update({ points: team2.points }).eq("id", team2.id);
  }

  // Mark as submitted
  match.submitted = true;

  setTeams(updatedTeams);

  // ✅ update rounds + matches
  const updatedRounds = [...rounds];
  const roundIndex = match.round;
  const matchIndex = updatedRounds[roundIndex].findIndex(m => m.id === match.id);
  updatedRounds[roundIndex][matchIndex] = match;

  const updatedMatches = [...matches];
  updatedMatches[match.id] = match;

  setRounds(updatedRounds);
  setMatches(updatedMatches);

  await addRounds(updatedRounds, updatedMatches);
};




  const generatePlayerMatches = (players1, players2, round) => {
    let sorted1 = [...players1].sort((a, b) => b.rating - a.rating);
    let sorted2 = [...players2].sort((a, b) => b.rating - a.rating);
    return sorted1.map((player, index) => ({
      player1: player.name,
      player2: sorted2[index] ? sorted2[index].name : "Bye",
      result: null
    }));
  };

  const generateRounds = () => {
    let shuffledTeams = [...teams];
    if (shuffledTeams.length % 2 !== 0) shuffledTeams.push({ name: "BYE", players: [], points: 0 });

    let numRounds = shuffledTeams.length - 1;
    let matchRounds = [];
    let allMatches = [];

    for (let round = 0; round < numRounds; round++) {
      let roundMatches = [];
      for (let i = 0; i < shuffledTeams.length / 2; i++) {
        let team1 = shuffledTeams[i];
        let team2 = shuffledTeams[shuffledTeams.length - 1 - i];
        if (team1.name !== "BYE" && team2.name !== "BYE") {
          let match = {
            id: allMatches.length,
            team1: team1.name,
            team2: team2.name,
            players1: team1.players,
            players2: team2.players,
            result: null,
            playerMatches: generatePlayerMatches(team1.players, team2.players, round),
            round: round
          };
          roundMatches.push(match);
          allMatches.push(match);
        }
      }
      matchRounds.push(roundMatches);
      shuffledTeams.splice(1, 0, shuffledTeams.pop());
    }

    setRounds(matchRounds);
    setMatches(allMatches);
    addRounds(matchRounds, allMatches);
 
    // window.location.reload()
  };

  const determineTiebreaker = (team1, team2) => {
    let team1Wins = team1.players.reduce((acc, player) => acc + player.wins, 0);
    let team2Wins = team2.players.reduce((acc, player) => acc + player.wins, 0);
    return team1Wins > team2Wins ? team1.name : team2Wins > team1Wins ? team2.name : "Still Tied";
  };
  return (
      <Routes>
        <Route path="/" element={
          <div className="container mx-auto px-4 py-8 max-w-6xl">
            <header className="mb-8 text-center">
              <h1 className="text-4xl font-bold text-white">CHS Chess Club Tournament Manager</h1>
                              <Button onClick={copyLatestRoundData} className="mt-4 mb-4">
                  📋 Copy Latest Round Data
                </Button>
            </header>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

              <AddTeamPage setNewTeam={setNewTeam} newTeam={newTeam} setNewPlayer={setNewPlayer} newPlayer={newPlayer} addPlayer={addPlayer} addTeam={addTeam}/>
              
              <TeamList teams={teams} generateRounds={generate1v1Rounds} clearPlayerPoints={clearPlayerPoints} clearRounds={clearRounds} clearTeams={clearTeams} clearTeamPoints={clearTeamPoints} />
              
            </div>
            
            {rounds.length > 0 && (
              <Rounds rounds={rounds} />
            )}
            
            <Leaderboard teams={teams} determineTiebreaker={determineTiebreaker}/>
          </div>
        } />
        <Route path="match/:matchId" element={<PlayerMatch matches={matches} recordPlayerMatchResult={recordPlayerMatchResult} RevokeSubmit={RevokeSubmit} Submit={Submit} />} />
      </Routes>
  );
};

export default AppTVT;